import React, {Component} from 'react'
import LoginModal from './LoginModal'

class EnsureUser extends Component {
  render() {
    let user = window.firebaseApp.auth().currentUser
    return (user && this.props.children) || <LoginModal open={true} />
  }
}

export default EnsureUser



// WEBPACK FOOTER //
// ./src/components/EnsureUser.jsx